import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Scissors, Package, Hammer, Sparkles } from 'lucide-react';

const Crafts = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a1e 0%, #1a0a2e 100%)',
      padding: '2rem',
      color: '#fff'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: '3rem',
            background: 'linear-gradient(135deg, #00ff88, #ffff00)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem',
            fontWeight: 'bold'
          }}>
            Crafts & Making
          </h1>
          <p style={{ color: '#888', fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto' }}>
            DIY project guides, craft tutorials, and maker space tools
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3rem'
        }}>
          <Card style={{
            padding: '1.5rem',
            background: 'rgba(0, 255, 136, 0.1)',
            border: '1px solid rgba(0, 255, 136, 0.3)'
          }}>
            <Scissors size={32} style={{ color: '#00ff88', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>DIY Projects</h3>
            <p style={{ color: '#888' }}>Step-by-step craft instructions</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(255, 255, 0, 0.1)',
            border: '1px solid rgba(255, 255, 0, 0.3)'
          }}>
            <Package size={32} style={{ color: '#ffff00', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Material Guide</h3>
            <p style={{ color: '#888' }}>Tools and materials recommendations</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(255, 165, 0, 0.1)',
            border: '1px solid rgba(255, 165, 0, 0.3)'
          }}>
            <Hammer size={32} style={{ color: '#ffa500', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Maker Space</h3>
            <p style={{ color: '#888' }}>Advanced fabrication and building</p>
          </Card>
        </div>

        <Card style={{
          padding: '2rem',
          background: 'rgba(10, 10, 30, 0.8)',
          border: '1px solid rgba(0, 255, 136, 0.3)',
          marginBottom: '2rem'
        }}>
          <h2 style={{ fontSize: '1.5rem', color: '#00ff88', marginBottom: '1.5rem' }}>Craft Tools</h2>
          <div style={{ color: '#888', lineHeight: '1.8' }}>
            <p>Comprehensive craft and maker widgets:</p>
            <ul style={{ marginTop: '1rem', paddingLeft: '2rem' }}>
              <li>Project Idea Generator</li>
              <li>Material Calculator & Cost Estimator</li>
              <li>Tutorial Finder</li>
              <li>3D Printing Design Tools</li>
              <li>Woodworking Planner</li>
              <li>Sewing Pattern Generator</li>
            </ul>
          </div>
        </Card>

        <Card style={{
          padding: '2rem',
          background: 'linear-gradient(135deg, rgba(0,255,136,0.1), rgba(255,255,0,0.1))',
          border: '2px solid #00ff88'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <Sparkles size={32} style={{ color: '#00ff88' }} />
            <h2 style={{ fontSize: '1.5rem', color: '#00ff88' }}>Crafts AI Advisor</h2>
          </div>
          <p style={{ color: '#ccc', marginBottom: '1.5rem' }}>
            Get crafting guidance from AI makers and artisans. Ask about techniques, materials, 
            project ideas, or any crafting question.
          </p>
          <Button style={{
            background: 'linear-gradient(135deg, #00ff88, #ffff00)',
            color: '#000',
            fontWeight: 'bold',
            padding: '1rem 2rem'
          }}>
            Chat with Crafts AI
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default Crafts;